import React from 'react';
import { useNavigate, useOutletContext, useParams, useSearchParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { BackIcon } from '../../../components/AppHeader';
import { useTranslation } from 'react-i18next';

export default function WelcomeScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { stageIdx, squadId } = useParams();
  const [searchParams] = useSearchParams();
  const { matchId, match, shooters } = useOutletContext();
  const stageIdxNum = parseInt(stageIdx, 10);
  const basePath = `/${matchId}/manage/scores`;
  const splitParam = searchParams.get('split');
  const qs = splitParam ? `?split=${splitParam}` : '';

  const squad = (match?.squads || []).find((s) => s.id === squadId);
  const squadShooters = shooters.filter((s) => s.squad === squadId && !s.cancelledParticipation);
  const allChecked = squadShooters.every((s) => (s.equipmentChecks || [])[stageIdxNum - 1]);

  const currentPath = `${basePath}/stage/${stageIdx}/squad/${squadId}`;

  return (
    <Box sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Button startIcon={<BackIcon />} onClick={() => navigate(`${basePath}/stage/${stageIdx}`)}>
          {t('common.back')}
        </Button>
        <Typography variant="subtitle1">
          {t('results.stageN', { n: stageIdx })} - {squad?.title || squadId}
        </Typography>
      </Box>

      {allChecked ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Typography variant="body1">{t('scoring.welcomeAllChecked')}</Typography>
          <Button
            fullWidth color="primary" variant="contained"
            onClick={() => navigate(`${currentPath}/score-mode${qs}`)}
            sx={{ py: 1.5 }}
          >
            {t('scoring.welcomeScore')}
          </Button>
          <Button
            fullWidth color="primary" variant="text"
            onClick={() => navigate(`${currentPath}/welcome-mode${qs}`)}
            sx={{ py: 1.5 }}
          >
            {t('scoring.welcomeRecheck')}
          </Button>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Typography variant="body1">{t('scoring.welcome')}</Typography>
          <Button
            fullWidth color="primary" variant="contained"
            onClick={() => navigate(`${currentPath}/welcome-mode${qs}`)}
            sx={{ py: 1.5 }}
          >
            {t('scoring.welcomeAttendance')}
          </Button>
          <Button
            fullWidth color="primary" variant="text"
            onClick={() => navigate(`${currentPath}/score-mode${qs}`)}
            sx={{ py: 1.5 }}
          >
            {t('scoring.welcomeScore')}
          </Button>
        </Box>
      )}
    </Box>
  );
}
